// assets
import { MessageOutlined } from '@ant-design/icons';
import { NavGroupType } from './types';

// icons
const icons = {
    MessageOutlined,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const chat: NavGroupType = {
    id: 'group-chat',
    title: 'menu.chat.title',
    type: 'group',
    children: {} as { [key: string]: any },
    disabled: {
        qlive_chat_report_message_list: {
            id: 'list-chat-reported-messages',
            title: 'menu.chat.reported_messages.list',
            type: 'item',
            url: '/chat/reported-messages',
            icon: icons.MessageOutlined,
            breadcrumbs: false,
        },
        qlive_chat_list: {
            id: 'list-chat-groups',
            title: 'menu.chat.groups.list',
            type: 'item',
            url: '/chat/groups',
            icon: icons.MessageOutlined,
            breadcrumbs: false,
        },
    },
};

export default chat;
